import { ICorporatePartner } from './corporate-partner.interface';

export class EdpPartner implements ICorporatePartner {
  public name = 'edp';
  public displayBusinessLogo = true;
  public updateBgColor = true;
  public restrictPaxToOne = false;
  public disableMiles = true;
  public displayInlineText = 'fare';
  public showPopupForEcert = true;
  public showBusinessText = true;
  public showBusinessMilesLabel = true;
}
